const gun = (n = 0) => new Date(Date.now() + n * 864e5).toISOString().slice(0, 10);
const saatSimdi = () => new Date().toTimeString().slice(0, 5);

export const BELGE_TUR = {
  siparis: { baslik: "Yeni Alınan Sipariş", tarihEtiket: "Sipariş / Düzenlenme Tarihi", ikinci: ["termin_tarihi", "Teslimat Tarihi"], uc: "/siparisler",
    git: (d) => `/siparisler/${d.id}`, kayitTur: "siparis", perm: "siparis:create" },
  irsaliye: { baslik: "Yeni Satış İrsaliyesi", tarihEtiket: "Düzenleme Tarihi", ikinci: ["sevk_tarihi", "Fiili Sevkiyat Tarihi"], saat: true, uc: "/sevkiyatlar/elle",
    git: () => "/sevkiyat?sekme=sevkiyatlar", kayitTur: "irsaliye", perm: "siparis:sevk" },
  teklif: { baslik: "Yeni Satış Proforması", tarihEtiket: "Düzenleme Tarihi", ikinci: ["gecerlilik_tarihi", "Geçerlilik Tarihi"], uc: "/teklifler",
    git: (d) => `/satis/teklifler/${d.id}`, kayitTur: "teklif", perm: "siparis:create" },
};

export const bosBelge = (ayar, tur) => ({
  cari_id: "", teslim_adresi: "", tarih: gun(0), termin_tarihi: gun(ayar?.termin_gun || 7), sevk_tarihi: gun(0), sevk_saati: saatSimdi(),
  gecerlilik_tarihi: gun(ayar?.teklif_gecerlilik_gun || 15), para_birimi: "TRY", kur: 1, takip_para_birimi: "TRY", aciklama: "",
  proje_id: "", etiketler: [], indirim_tipi: "yuzde", indirim: 0, yuvarlama: 0, satirlar: [], tip: tur === "teklif" ? "proforma" : undefined,
});

export const satirTutar = (s) => {
  const net = (Number(s.miktar) || 0) * (Number(s.birim_fiyat) || 0);
  return { net, kdv: (net * (Number(s.kdv_orani) || 0)) / 100 };
};

export const hesapla = (f) => {
  const ara = f.satirlar.reduce((t, s) => t + satirTutar(s).net, 0);
  const kdvHam = f.satirlar.reduce((t, s) => t + satirTutar(s).kdv, 0);
  const indirim = Math.min(ara, f.indirim_tipi === "yuzde" ? (ara * (Number(f.indirim) || 0)) / 100 : Number(f.indirim) || 0);
  const oran = ara > 0 ? 1 - indirim / ara : 1;
  const kdv = kdvHam * oran;
  return { ara, indirim, kdv, genel: ara - indirim + kdv + (Number(f.yuvarlama) || 0) };
};

export const govde = (tur, f) => {
  const ortak = { cari_id: f.cari_id, teslim_adresi: f.teslim_adresi, tarih: f.tarih, para_birimi: f.para_birimi, kur: f.kur, takip_para_birimi: f.takip_para_birimi,
    proje_id: f.proje_id || null, etiketler: f.etiketler.join(", "), indirim_tipi: f.indirim_tipi, indirim: Number(f.indirim) || 0, yuvarlama: Number(f.yuvarlama) || 0 };
  const kalemler = f.satirlar.map((s) => ({ urun_id: s.urun_id, miktar: Number(s.miktar), birim_fiyat: Number(s.birim_fiyat), aciklama: s.aciklama || "" }));
  if (tur === "siparis") return { ...ortak, termin_tarihi: f.termin_tarihi, notlar: f.aciklama, kalemler };
  if (tur === "irsaliye") return { ...ortak, sevk_tarihi: f.sevk_tarihi, sevk_saati: f.sevk_saati, aciklama: f.aciklama, kalemler };
  return { ...ortak, tip: f.tip || "proforma", gecerlilik_tarihi: f.gecerlilik_tarihi, notlar: f.aciklama, portalda: true, kalemler };
};

const SABLON_ANAHTAR = "aciklama_sablonlari";
export const sablonlar = () => { try { return JSON.parse(localStorage.getItem(SABLON_ANAHTAR) || "[]"); } catch { return []; } };
export const sablonKaydet = (metin) => localStorage.setItem(SABLON_ANAHTAR, JSON.stringify([...new Set([metin, ...sablonlar()])].slice(0, 20)));
